<template>
    <div>
          <!----- Header Title ----->
      <div class="row">
        <div class="col-md-6">
          <div>
            <h3 class="page-title mb-1">
                  {{ this.$route.meta.title }}
            </h3>
          </div>
          <div class="breadcrumb-container">
            <ul class="uk-breadcrumb">
              <li><span>Admin</span></li>
              <li><a href="">{{ this.$route.meta.title }}</a></li>
            </ul>
          </div>
        </div>
        <div class="col-md-6 relative"></div>
      </div>
      <div class="row mt-2">
        <div class="col-md-8">
        </div>
        <div class="col-md-4 relative">
          <div class="uk-position-bottom-right pr-3">
            <div class="mb-3 text-right">
              <router-link :to="'/new/commission-partner/'">
                <a class="outline-btn pt-1" style="padding: 5px 10px;">
                    <i class="fas fa-plus mr-2"></i>Add Commission Partner
                </a>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table data-table table-round table-hover">
          <thead>
            <tr>
              <th>
                    ID
                    <Sort column="id" />
                  </th>
                  <th>
                    Name
                    <Sort column="name_en" />
                  </th>
                  <th>
                    Email Address
                  </th>
                  <th>
                    Phone Number
                  </th>
                  <th>
                    Contact Person
                  </th>
                  <th>
                    Internal Notes
                  </th>
            </tr>
          </thead>
          <tbody>
                <tr>
                  <td>1</td>
                  <td>Hanah Salazar</td>
                  <td>hannahen@gmail.com</td>
                  <td>091234567789</td>
                  <td>Alene Goldner</td>
                  <td></td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>Hanah Salazar</td>
                  <td>hannahen@gmail.com</td>
                  <td>091234567789</td>
                  <td>Alene Goldner</td>
                  <td></td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>Hanah Salazar</td>
                  <td>hannahen@gmail.com</td>
                  <td>091234567789</td>
                  <td>Alene Goldner</td>
                  <td></td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>Hanah Salazar</td>
                  <td>hannahen@gmail.com</td>
                  <td>091234567789</td>
                  <td>Alene Goldner</td>
                  <td></td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>Hanah Salazar</td>
                  <td>hannahen@gmail.com</td>
                  <td>091234567789</td>
                  <td>Alene Goldner</td>
                  <td></td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>Hanah Salazar</td>
                  <td>hannahen@gmail.com</td>
                  <td>091234567789</td>
                  <td>Alene Goldner</td>
                  <td></td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>Hanah Salazar</td>
                  <td>hannahen@gmail.com</td>
                  <td>091234567789</td>
                  <td>Alene Goldner</td>
                  <td></td>
                </tr>
              </tbody>
          <tfoot>
          </tfoot>
        </table>
      </div>

      <!-- PAGINATION -->
      <div class="card-footer pb-0 pt-3" v-if="numberOfPage > 1">
            <jw-pagination
              :items="pages"
              @changePage="onChangePage"
              :pageSize="limit"
              :styles="customStyles"
              :labels="customLabels"
            ></jw-pagination>
          </div>
    </div>
    
  </template>
  
  
  
  <script>

  export default {
    
  }
  </script>
  
  <style scoped>
  .card-footer {
    text-align: right;
    position: relative;
    background: #fff;
  }
  .pagination {
    top: 20px;
    position: absolute;
    right: 0px;
    align-content: flex-end;
    text-align: end;
  }
  </style>